import { MeasureRule, MeasureRuleClass, Misura, MisuraClass } from '../types';
import { atom } from 'recoil';
import { getUUID } from '../../utils';

export const measureState = atom<Misura>({
  key: getUUID(),
  default: new MisuraClass(),
});

export const measuresState = atom<Misura[]>({
  key: getUUID(),
  default: [],
});

export const measureLoaderState = atom<boolean>({
  key: getUUID(),
  default: false,
});

export const measuresLoaderState = atom<boolean>({
  key: getUUID(),
  default: false,
});

export const measureRuleState = atom<MeasureRule>({
  key: getUUID(),
  default: new MeasureRuleClass(),
});

export const measureRuleLoaderState = atom<boolean>({
  key: getUUID(),
  default: false,
});

export const measureRulesState = atom<MeasureRule[]>({
  key: getUUID(),
  default: [],
});

export const measureRulesLoaderState = atom<boolean>({
  key: getUUID(),
  default: false,
});
